import { render, staticRenderFns } from "./Ppkprovinsi.vue?vue&type=template&id=d929775e"
import script from "./Ppkprovinsi.vue?vue&type=script&lang=js"
export * from "./Ppkprovinsi.vue?vue&type=script&lang=js"
import style0 from "./Ppkprovinsi.vue?vue&type=style&index=0&id=d929775e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports